import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component'

function Volunteer() {
    return (
        <>
            <div className="flex flex-col px-5 mt-20">
                <div className="self-start text-5xl font-bold text-right whitespace-nowrap text-zinc-900">
                    كن متطوعًا{" "}
                </div>
                <div className="mt-8 w-full text-lg text-right text-zinc-900 max-md:max-w-full">
                    &quot;ندعو المنظمات والمؤسسات إلى الانضمام إلى مؤسسة الخير كشريك في
                    تحقيق التأثير الإيجابي وتقديم الدعم للمحتاجين في مجتمعاتنا. معًا، يمكننا
                    صنع فرق حقيقي وبناء عالم أفضل للجميع.&quot;
                </div>
                <div className="mt-14 w-full max-md:mt-10 max-md:max-w-full">
                    <div className="flex gap-5 max-md:flex-col max-md:gap-0 max-md:">
                        <div className="flex flex-col ml-5 w-6/12 max-md:ml-0 max-md:w-full">
                            <div className="flex flex-col grow p-8 w-full text-base font-medium bg-white rounded-3xl border border-solid border-neutral-200 text-slate-700 max-md:px-5 max-md:mt-5 max-md:max-w-full">
                                <div className="font-light text-right text-neutral-500 max-md:max-w-full">
                                    يرجى إدخال البيانات التالية
                                </div>
                                <div className="self-start mt-6 whitespace-nowrap">
                                    الاسم الثلاثي
                                </div>
                                <div className="flex flex-col justify-center px-3.5 py-2.5 mt-1.5 text-sm leading-6 text-right text-gray-500 bg-white rounded-lg border border-gray-300 border-solid shadow-sm max-md:max-w-full">
                                    <div className="flex gap-2 justify-between max-md:flex-wrap max-md:max-w-full">
                                        <LazyLoadImage
                                            loading="lazy"
                                            src="https://cdn.builder.io/api/v1/image/assets/TEMP/32a06a3503d63c74aa46a421ee424f0c17ab8ea39b7c2d804119af67172d8099?"
                                            className="my-auto w-5 aspect-square"
                                        />
                                        <div className="grow max-md:max-w-full">
                                            يرجى كتابة الاسم هنا
                                        </div>
                                    </div>
                                </div>
                                <div className="self-start mt-5 whitespace-nowrap">
                                    البريد الالكتروني
                                </div>
                                <div className="flex flex-col justify-center px-3.5 py-2.5 mt-1.5 text-sm leading-6 text-right text-gray-500 bg-white rounded-lg border border-gray-300 border-solid shadow-sm max-md:max-w-full">
                                    <div className="flex gap-2 justify-between max-md:flex-wrap max-md:max-w-full">
                                        <LazyLoadImage
                                            loading="lazy"
                                            src="https://cdn.builder.io/api/v1/image/assets/TEMP/6b63a1bbb10a8ad48c7dc6810d7bb845dc657075e06f7d95434ebeb112a0c473?"
                                            className="my-auto w-5 aspect-square"
                                        />
                                        <div className="grow max-md:max-w-full">
                                            يرجى كتابة البريد الالكتروني هنا
                                        </div>
                                    </div>
                                </div>
                                <div className="self-start mt-5 whitespace-nowrap">
                                    تاريخ الميلاد
                                </div>
                                <div className="flex flex-col justify-center px-3.5 py-2.5 mt-1.5 text-sm leading-6 text-right text-gray-500 whitespace-nowrap bg-white rounded-lg border border-gray-300 border-solid shadow-sm max-md:max-w-full">
                                    <div className="flex gap-2 justify-between max-md:flex-wrap max-md:max-w-full">
                                        <div className="grow max-md:max-w-full">DD/MM/YYYY</div>
                                        <LazyLoadImage
                                            loading="lazy"
                                            src="https://cdn.builder.io/api/v1/image/assets/TEMP/df5656ebae8aa022ae286701f85266fa2823893048ffd1f80c594360155af511?"
                                            className="w-6 aspect-square"
                                        />
                                    </div>
                                </div>
                                <div className="self-start mt-5 whitespace-nowrap">رقم الهاتف</div>
                                <div className="flex gap-2 justify-between px-3.5 py-2.5 mt-1.5 text-sm leading-6 text-right text-gray-500 bg-white rounded-lg border border-gray-300 border-solid shadow-sm max-md:flex-wrap max-md:max-w-full">
                                    <div className="grow max-md:max-w-full">
                                        اكتب كلمة المرور هنا
                                    </div>
                                    <LazyLoadImage
                                        loading="lazy"
                                        src="https://cdn.builder.io/api/v1/image/assets/TEMP/aa1062db4026b3413a62e8fcf071bee60d5880948733f8e245fddcc25f655dfe?"
                                        className="w-6 aspect-square"
                                    />
                                </div>
                                <div className="self-start mt-5">العنوان</div>
                                <div className="justify-center px-3.5 py-2.5 mt-1.5 text-sm leading-6 text-right text-gray-500 bg-white rounded-lg border border-gray-300 border-solid shadow-sm max-md:max-w-full">
                                    اكتب العنوان هنا
                                </div>
                                <div className="self-start mt-5 whitespace-nowrap">
                                    المستوى التعليمي
                                </div>
                                <div className="justify-center px-3.5 py-2.5 mt-1.5 text-sm leading-6 text-right text-gray-500 bg-white rounded-lg border border-gray-300 border-solid shadow-sm max-md:max-w-full">
                                    اكتب التفاصيل هنا
                                </div>
                                <div className="self-start mt-5">المهنة</div>
                                <div className="justify-center px-3.5 py-2.5 mt-1.5 text-sm leading-6 text-right text-gray-500 bg-white rounded-lg border border-gray-300 border-solid shadow-sm max-md:max-w-full">
                                    اكتب التفاصيل هنا
                                </div>
                                <div className="self-start mt-5 whitespace-nowrap">
                                    كيف يمكنك المساهمة في الخير ؟
                                </div>
                                <div className="flex gap-2 justify-between px-3.5 py-2.5 mt-1.5 text-sm leading-6 text-right text-gray-500 bg-white rounded-lg border border-gray-300 border-solid shadow-sm max-md:flex-wrap max-md:max-w-full">
                                    <LazyLoadImage
                                        loading="lazy"
                                        src="https://cdn.builder.io/api/v1/image/assets/TEMP/4cd540013278e9508615c87f31c47d39b444cd1d16eae81e9a9b36845244e08e?"
                                        className="my-auto w-5 aspect-square"
                                    />
                                    <div className="grow max-md:max-w-full">اكتب التفاصيل هنا</div>
                                </div>
                                <div className="justify-center text-center items-center px-16 py-2 mt-6 text-sm font-semibold leading-5 text-white whitespace-nowrap bg-blue-600 rounded-lg border border-blue-500 border-solid shadow-sm max-md:px-5 max-md:max-w-full">
                                    ارسال
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-col w-6/12 max-md:ml-0 max-md:w-full">
                            <LazyLoadImage
                                loading="lazy"
                                srcSet="https://s3-alpha-sig.figma.com/LazyLoadImage/5159/ce81/e7515166122790e15605809b0e617931?Expires=1709510400&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=LhnrRXt0xPwuOV3FzYTLQyyGj4qVu2lfWEPMvZYFZwgnhLFd9tAa~HoQobID6ijNyFr1IOGBbXfsP0igWMkKj0D0wSWIABtNUz-7dvardpdPZK4VpVz~9tXSYUybAXmAb489eBqfV5m3pfrpE4-w0tuJBBMFlCpLq76e0k7vdO~5LLRJAeTc7uoqx4YDcqjeK1t4iC329MzbFEDwaoFMv6OaliJLqtITg0VclTWGN0xrRtgx84-Q40pY2J8C-f-GcWdUXPLP2gb3SJDg-Q5dXlbG3yw08L5ThOPWoj-MLqZdbkkFalgpoGEsuVqNiRh5tse41ifSGn-buvL8DF8OWQ__"
                                className="grow self-stretch w-full aspect-[0.6] max-md:mt-5 max-md:max-w-full object-cover rounded-lg"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Volunteer